import axios from 'axios'

import { ExchangeRateInterface } from '../Interfaces/ExchangeRateInterface'
import { getRequestConfig } from './index'

export async function getExchangeRate(): Promise<ExchangeRateInterface> {
  const { data } = await axios.get('/platform/v4/exchange-rates', getRequestConfig())
  return data
}
